import { Observable } from "rxjs";
import * as _ from "lodash";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IUserGroupsAllResponse } from "../models/IUserGroups.model";
import { URLConfig } from "../network/urlStore";


export const getUserGroups = ( queryParams?: Array<{
  key: OdQueryParam | AgTechQueryParam;
  value: string[];
}>,): Observable<IUserGroupsAllResponse> => {
  let url = URLConfig.getUserGroupsMasterDataURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IUserGroupsAllResponse;
          const sortedTeams = _.sortBy(response?.userGroups ?? [], "name");
          const teamsData = { ...response, crops: sortedTeams };
          subscriber.next(teamsData);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};
